(() => {
  'use strict';
  // Exact visible names and order from artbysehgal.com, captured 15 October 2026.
  const currencies = [
  {
    "code": "USD",
    "label": "US Dollar (USD)"
  },
  {
    "code": "EUR",
    "label": "Euro (EUR)"
  },
  {
    "code": "GBP",
    "label": "British Pound (GBP)"
  },
  {
    "code": "CAD",
    "label": "Canadian Dollar (CAD)"
  },
  {
    "code": "AED",
    "label": "United Arab Emirates Dirham (AED)"
  },
  {
    "code": "ALL",
    "label": "Albanian Lek (ALL)"
  },
  {
    "code": "AFN",
    "label": "Afghan Afghani (AFN)"
  },
  {
    "code": "AMD",
    "label": "Armenian Dram (AMD)"
  },
  {
    "code": "AOA",
    "label": "Angolan Kwanza (AOA)"
  },
  {
    "code": "ARS",
    "label": "Argentine Peso (ARS)"
  },
  {
    "code": "AUD",
    "label": "Australian Dollar (AUD)"
  },
  {
    "code": "AWG",
    "label": "Aruban Florin (AWG)"
  },
  {
    "code": "AZN",
    "label": "Azerbaijani Manat (AZN)"
  },
  {
    "code": "BIF",
    "label": "Burundian Franc (BIF)"
  },
  {
    "code": "BBD",
    "label": "Barbadian Dollar (BBD)"
  },
  {
    "code": "BDT",
    "label": "Bangladeshi Taka (BDT)"
  },
  {
    "code": "BSD",
    "label": "Bahamian Dollar (BSD)"
  },
  {
    "code": "BHD",
    "label": "Bahraini Dinar (BHD)"
  },
  {
    "code": "BMD",
    "label": "Bermudan Dollar (BMD)"
  },
  {
    "code": "BYN",
    "label": "Belarusian Ruble (BYN)"
  },
  {
    "code": "BZD",
    "label": "Belize Dollar (BZD)"
  },
  {
    "code": "BTN",
    "label": "Bhutanese Ngultrum (BTN)"
  },
  {
    "code": "BAM",
    "label": "Bosnia-Herzegovina Convertible Mark (BAM)"
  },
  {
    "code": "BRL",
    "label": "Brazilian Real (BRL)"
  },
  {
    "code": "BOB",
    "label": "Bolivian Boliviano (BOB)"
  },
  {
    "code": "BWP",
    "label": "Botswanan Pula (BWP)"
  },
  {
    "code": "BND",
    "label": "Brunei Dollar (BND)"
  },
  {
    "code": "BGN",
    "label": "Bulgarian Lev (BGN)"
  },
  {
    "code": "CDF",
    "label": "Congolese Franc (CDF)"
  },
  {
    "code": "CHF",
    "label": "Swiss Franc (CHF)"
  },
  {
    "code": "CLP",
    "label": "Chilean Peso (CLP)"
  },
  {
    "code": "CNY",
    "label": "Chinese Yuan (CNY)"
  },
  {
    "code": "COP",
    "label": "Colombian Peso (COP)"
  },
  {
    "code": "CRC",
    "label": "Costa Rican Colon (CRC)"
  },
  {
    "code": "CZK",
    "label": "Czech Republic Koruna (CZK)"
  },
  {
    "code": "DJF",
    "label": "Djiboutian Franc (DJF)"
  },
  {
    "code": "DKK",
    "label": "Danish Krone (DKK)"
  },
  {
    "code": "DOP",
    "label": "Dominican Peso (DOP)"
  },
  {
    "code": "DZD",
    "label": "Algerian Dinar (DZD)"
  },
  {
    "code": "EGP",
    "label": "Egyptian Pound (EGP)"
  },
  {
    "code": "ETB",
    "label": "Ethiopian Birr (ETB)"
  },
  {
    "code": "FJD",
    "label": "Fijian Dollar (FJD)"
  },
  {
    "code": "FKP",
    "label": "Falkland Islands Pound (FKP)"
  },
  {
    "code": "GIP",
    "label": "Gibraltar Pound (GIP)"
  },
  {
    "code": "GHS",
    "label": "Ghanaian Cedi (GHS)"
  },
  {
    "code": "GMD",
    "label": "Gambian Dalasi (GMD)"
  },
  {
    "code": "GNF",
    "label": "Guinean Franc (GNF)"
  },
  {
    "code": "GTQ",
    "label": "Guatemalan Quetzal (GTQ)"
  },
  {
    "code": "GEL",
    "label": "Georgian Lari (GEL)"
  },
  {
    "code": "HRK",
    "label": "Croatian Kuna (HRK)"
  },
  {
    "code": "HNL",
    "label": "Honduran Lempira (HNL)"
  },
  {
    "code": "HKD",
    "label": "Hong Kong Dollar (HKD)"
  },
  {
    "code": "HTG",
    "label": "Haitian Gourde (HTG)"
  },
  {
    "code": "HUF",
    "label": "Hungarian Forint (HUF)"
  },
  {
    "code": "IDR",
    "label": "Indonesian Rupiah (IDR)"
  },
  {
    "code": "ILS",
    "label": "Israeli New Shekel (ILS)"
  },
  {
    "code": "ISK",
    "label": "Icelandic Krona (ISK)"
  },
  {
    "code": "INR",
    "label": "Indian Rupee (INR)"
  },
  {
    "code": "IQD",
    "label": "Iraqi Dinar (IQD)"
  },
  {
    "code": "IRR",
    "label": "Iranian Rial (IRR)"
  },
  {
    "code": "JMD",
    "label": "Jamaican Dollar (JMD)"
  },
  {
    "code": "JPY",
    "label": "Japanese Yen (JPY)"
  },
  {
    "code": "JOD",
    "label": "Jordanian Dinar (JOD)"
  },
  {
    "code": "KES",
    "label": "Kenyan Shilling (KES)"
  },
  {
    "code": "KGS",
    "label": "Kyrgystani Som (KGS)"
  },
  {
    "code": "KHR",
    "label": "Cambodian Riel (KHR)"
  },
  {
    "code": "KMF",
    "label": "Comorian Franc (KMF)"
  },
  {
    "code": "KRW",
    "label": "South Korean Won (KRW)"
  },
  {
    "code": "KWD",
    "label": "Kuwaiti Dinar (KWD)"
  },
  {
    "code": "KYD",
    "label": "Cayman Islands Dollar (KYD)"
  },
  {
    "code": "KZT",
    "label": "Kazakhstani Tenge (KZT)"
  },
  {
    "code": "LBP",
    "label": "Lebanese Pound (LBP)"
  },
  {
    "code": "LKR",
    "label": "Sri Lankan Rupee (LKR)"
  },
  {
    "code": "LRD",
    "label": "Liberian Dollar (LRD)"
  },
  {
    "code": "LSL",
    "label": "Lesotho Loti (LSL)"
  },
  {
    "code": "LYD",
    "label": "Libyan Dinar (LYD)"
  },
  {
    "code": "MAD",
    "label": "Moroccan Dirham (MAD)"
  },
  {
    "code": "MDL",
    "label": "Moldovan Leu (MDL)"
  },
  {
    "code": "MGA",
    "label": "Malagasy Ariary (MGA)"
  },
  {
    "code": "MMK",
    "label": "Myanmar Kyat (MMK)"
  },
  {
    "code": "MKD",
    "label": "Macedonian Denar (MKD)"
  },
  {
    "code": "MOP",
    "label": "Macanese Pataca (MOP)"
  },
  {
    "code": "MUR",
    "label": "Mauritian Rupee (MUR)"
  },
  {
    "code": "MVR",
    "label": "Maldivian Rufiyaa (MVR)"
  },
  {
    "code": "MWK",
    "label": "Malawian Kwacha (MWK)"
  },
  {
    "code": "MXN",
    "label": "Mexican Peso (MXN)"
  },
  {
    "code": "MYR",
    "label": "Malaysian Ringgit (MYR)"
  },
  {
    "code": "MZN",
    "label": "Mozambican Metical (MZN)"
  },
  {
    "code": "NAD",
    "label": "Namibian Dollar (NAD)"
  },
  {
    "code": "NPR",
    "label": "Nepalese Rupee (NPR)"
  },
  {
    "code": "NZD",
    "label": "New Zealand Dollar (NZD)"
  },
  {
    "code": "NIO",
    "label": "Nicaraguan Cordoba (NIO)"
  },
  {
    "code": "NOK",
    "label": "Norwegian Krone (NOK)"
  },
  {
    "code": "OMR",
    "label": "Omani Rial (OMR)"
  },
  {
    "code": "PAB",
    "label": "Panamanian Balboa (PAB)"
  },
  {
    "code": "PKR",
    "label": "Pakistani Rupee (PKR)"
  },
  {
    "code": "PGK",
    "label": "Papua New Guinean Kina (PGK)"
  },
  {
    "code": "PEN",
    "label": "Peruvian Nuevo Sol (PEN)"
  },
  {
    "code": "PHP",
    "label": "Philippine Peso (PHP)"
  },
  {
    "code": "PLN",
    "label": "Polish Zloty (PLN)"
  },
  {
    "code": "QAR",
    "label": "Qatari Rial (QAR)"
  },
  {
    "code": "RON",
    "label": "Romanian Leu (RON)"
  },
  {
    "code": "RUB",
    "label": "Russian Ruble (RUB)"
  },
  {
    "code": "RWF",
    "label": "Rwandan Franc (RWF)"
  },
  {
    "code": "SAR",
    "label": "Saudi Riyal (SAR)"
  },
  {
    "code": "STD",
    "label": "Sao Tome and Principe Dobra (STD)"
  },
  {
    "code": "RSD",
    "label": "Serbian Dinar (RSD)"
  },
  {
    "code": "SCR",
    "label": "Seychellois Rupee (SCR)"
  },
  {
    "code": "SGD",
    "label": "Singapore Dollar (SGD)"
  },
  {
    "code": "SYP",
    "label": "Syrian Pound (SYP)"
  },
  {
    "code": "SEK",
    "label": "Swedish Krona (SEK)"
  },
  {
    "code": "TWD",
    "label": "New Taiwan Dollar (TWD)"
  },
  {
    "code": "THB",
    "label": "Thai Baht (THB)"
  },
  {
    "code": "TZS",
    "label": "Tanzanian Shilling (TZS)"
  },
  {
    "code": "TTD",
    "label": "Trinidad and Tobago Dollar (TTD)"
  },
  {
    "code": "TND",
    "label": "Tunisian Dinar (TND)"
  },
  {
    "code": "TRY",
    "label": "Turkish Lira (TRY)"
  },
  {
    "code": "SBD",
    "label": "Solomon Islands Dollar (SBD)"
  },
  {
    "code": "SDG",
    "label": "Sudanese Pound (SDG)"
  },
  {
    "code": "SLL",
    "label": "Sierra Leonean Leone (SLL)"
  },
  {
    "code": "SRD",
    "label": "Surinamese Dollar (SRD)"
  },
  {
    "code": "SZL",
    "label": "Swazi Lilangeni (SZL)"
  },
  {
    "code": "TJS",
    "label": "Tajikistani Somoni (TJS)"
  },
  {
    "code": "TOP",
    "label": "Tongan Paanga (TOP)"
  },
  {
    "code": "TMT",
    "label": "Turkmenistani Manat (TMT)"
  },
  {
    "code": "UAH",
    "label": "Ukrainian Hryvnia (UAH)"
  },
  {
    "code": "UGX",
    "label": "Ugandan Shilling (UGX)"
  },
  {
    "code": "UYU",
    "label": "Uruguayan Peso (UYU)"
  },
  {
    "code": "UZS",
    "label": "Uzbekistan Som (UZS)"
  },
  {
    "code": "VEF",
    "label": "Venezuelan Bolivar (VEF)"
  },
  {
    "code": "VND",
    "label": "Vietnamese Dong (VND)"
  },
  {
    "code": "VUV",
    "label": "Vanuatu Vatu (VUV)"
  },
  {
    "code": "WST",
    "label": "Samoan Tala (WST)"
  },
  {
    "code": "XAF",
    "label": "Central African CFA Franc (XAF)"
  },
  {
    "code": "XPF",
    "label": "CFP Franc (XPF)"
  },
  {
    "code": "YER",
    "label": "Yemeni Rial (YER)"
  },
  {
    "code": "ZAR",
    "label": "South African Rand (ZAR)"
  }
];
  const decorated = new WeakSet();
  const mobileDecorated = new WeakSet();
  const watched = new WeakSet();
  function syncMobile() {
    const desktop = document.querySelector('[data-wp-currency]');
    const sourceFlag = desktop?.querySelector('.wp-currency__flag');
    const code = sourceFlag?.src.match(/\/([A-Z]{3})\.png/)?.[1];
    if (!code) return;
    document.querySelectorAll('.wp-currency--mobile').forEach(root => {
      const select = root.querySelector('[data-cb-currency-select]');
      if (!select) return;
      select.value = code;
      const trigger = root.querySelector('.wp-currency__trigger');
      const flag = root.querySelector('.wp-currency__flag');
      if (trigger.getAttribute('aria-label') !== 'Currency: ' + code) trigger.setAttribute('aria-label', 'Currency: ' + code);
      if (flag.src !== sourceFlag.src) flag.src = sourceFlag.src;
    });
  }
  function updateMobile() {
    const desktop = document.querySelector('[data-wp-currency]');
    if (!desktop || !decorated.has(desktop.querySelector('.wp-currency__chooser'))) return;
    if (!watched.has(desktop)) {
      watched.add(desktop);
      new MutationObserver(syncMobile).observe(desktop, { attributes: true, subtree: true, attributeFilter: ['aria-label', 'src'] });
    }
    document.querySelectorAll('.wp-currency--mobile').forEach(root => {
      if (mobileDecorated.has(root)) return;
      const panel = root.querySelector('.wp-currency__panel');
      const trigger = root.querySelector('.wp-currency__trigger');
      const countrySelect = panel?.querySelector('select');
      if (!panel || !trigger || !countrySelect) return;
      mobileDecorated.add(root);
      countrySelect.hidden = true;
      countrySelect.style.display = 'none';
      const select = document.createElement('select');
      select.id = countrySelect.id + 'Currency';
      select.className = countrySelect.className;
      select.dataset.cbCurrencySelect = '';
      select.setAttribute('aria-label', 'Currency');
      currencies.forEach(currency => select.add(new Option(currency.label, currency.code)));
      countrySelect.after(select);
      const label = panel.querySelector('label');
      if (label) { label.textContent = 'Currency'; label.htmlFor = select.id; }
      trigger.addEventListener('click', event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        panel.hidden = !panel.hidden;
        trigger.setAttribute('aria-expanded', String(!panel.hidden));
        if (!panel.hidden) select.focus();
      }, true);
      select.addEventListener('change', () => {
        const option = desktop.querySelector('[data-currency="' + select.value + '"]');
        option?.click();
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
        syncMobile();
      });
      select.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      });
    });
    syncMobile();
  }
  function updateLists() {
    document.querySelectorAll('[data-wp-currency] .wp-currency__chooser').forEach(list => {
      if (decorated.has(list)) return;
      const options = new Map(Array.from(list.querySelectorAll('[data-currency]')).map(option => [option.dataset.currency, option]));
      // Wait for the currency app to finish constructing its options.
      if (!currencies.every(currency => options.has(currency.code))) return;
      list.style.width = 'min(420px, calc(100vw - 32px))';
      const ordered = currencies.map(currency => {
        const option = options.get(currency.code);
        const flag = option.querySelector('img');
        option.style.whiteSpace = 'normal';
        option.replaceChildren(...(flag ? [flag] : []), document.createTextNode(currency.label));
        return option;
      });
      decorated.add(list);
      // Move the existing options, preserving app delegation and selection data.
      list.replaceChildren(...ordered);
    });
    updateMobile();
  }
  updateLists();
  new MutationObserver(updateLists).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', updateLists);
})();
